import { DATES } from 'app/_constants/dates.constant';
import * as angular from 'angular';

class SecondarySetupSectionComponentCtrl implements ng.IController {
    proposal: ProposalDto;

    constructor(private DATES: DATES) {}

    $onInit() {}
}

angular.module('app').component('pkpSecondarySetupSection', {
    controller: SecondarySetupSectionComponentCtrl,
    template: require('app/secondary-trading/secondary-setup-section.component.html'),
    bindings: {
        proposal: '<'
    }
});
